var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.72592 3.00781C3.75699 3.00781 2.96887 3.79593 2.96887 4.76486C2.96887 5.73364 3.75699 6.52191 4.72592 6.52191C5.6947 6.52191 6.48297 5.73364 6.48297 4.76486C6.48297 3.79593 5.6947 3.00781 4.72592 3.00781ZM4.72592 5.35049C4.40289 5.35049 4.14014 5.08774 4.14014 4.76486C4.14014 4.44183 4.40289 4.17908 4.72592 4.17908C5.0488 4.17908 5.31155 4.44183 5.31155 4.76486C5.31155 5.08774 5.0488 5.35049 4.72592 5.35049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.82587 13.5493H2.96893C1.67712 13.5493 0.626099 14.6002 0.626099 15.892C0.626099 17.1838 1.67712 18.2349 2.96893 18.2349H12.4797C12.7216 18.9166 13.3725 19.4063 14.1361 19.4063C15.105 19.4063 15.8931 18.618 15.8931 17.6492C15.8931 16.8857 15.4035 16.2346 14.7219 15.9929V13.5493H20.6261L18.2833 11.2065L20.6261 8.86383H14.7219V7.69241H13.5504V15.9929C13.0521 16.1696 12.6566 16.5651 12.4797 17.0634H2.96893C2.32303 17.0634 1.79752 16.5379 1.79752 15.892C1.79752 15.2461 2.32303 14.7208 2.96893 14.7208H8.82587C10.1177 14.7208 11.1685 13.6697 11.1685 12.3779C11.1685 11.0861 10.1177 10.0351 8.82587 10.0351H5.89694L8.00815 7.21863C8.55731 6.4856 8.82572 5.61829 8.82572 4.76395C8.82572 2.5032 6.98657 0.664062 4.72598 0.664062C2.46524 0.664062 0.626099 2.5032 0.626099 4.76395C0.626099 5.65628 0.908844 6.50513 1.44382 7.21893L4.43301 11.2065H8.82587C9.47177 11.2065 9.99713 11.732 9.99713 12.3779C9.99713 13.0238 9.47177 13.5493 8.82587 13.5493ZM17.7982 10.0351L16.6268 11.2065L17.7982 12.3779H14.7219V10.0351H17.7982ZM14.1361 17.0634C14.4591 17.0634 14.7219 17.3262 14.7219 17.6492C14.7219 17.9721 14.4591 18.2349 14.1361 18.2349C13.8132 18.2349 13.5504 17.9721 13.5504 17.6492C13.5504 17.3262 13.8132 17.0634 14.1361 17.0634ZM2.38116 6.51627C1.99939 6.00693 1.79752 5.40085 1.79752 4.76395C1.79752 3.14911 3.11115 1.83548 4.72598 1.83548C6.34067 1.83548 7.65445 3.14911 7.65445 4.76395C7.65445 5.41809 7.44113 6.02188 7.0708 6.51611L4.72598 9.64432L2.38116 6.51627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.665161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.bd90693a00660c86a7a336c8e2652855.svg";
export { ForwardRef as ReactComponent };